import { ErrorLogComponent } from '@cian/error-log-component';

import { type FC } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { extractUndefined } from '@/packages/utils/extractUndefined';

import { ContactActions } from './components/ContactActions';
import { DocumentsChecked } from './components/DocumentsChecked';
import { PublisherAvatarContainer } from './components/PublisherAvatar';
import { PublisherCardLayoutContainer } from './components/PublisherCardLayout';
import { PublisherNameWithBadges } from './components/PublisherNameWithBadges';
import { PublisherType } from './components/PublisherType/PublisherType';

export const CardPublisherContainer: FC = () => {
  const { extendedProperties: { documentsCheckedLabel, brandingLevel } = {}, typeLabels } =
    useCardOfferPublisherContext();
  const { logger } = useListingAppContext();

  return (
    <ErrorLogComponent level="error" logger={logger}>
      <PublisherCardLayoutContainer
        avatar={<PublisherAvatarContainer />}
        brandingLevel={extractUndefined(brandingLevel)}
        contactActions={<ContactActions />}
        documentsChecked={!!documentsCheckedLabel && <DocumentsChecked text={documentsCheckedLabel} type="label" />}
        nameWithBadges={<PublisherNameWithBadges />}
        type={!!typeLabels && <PublisherType labels={typeLabels} />}
      />
    </ErrorLogComponent>
  );
};
